import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink, TreeLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'

export function MemoriesAddedMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const personId = messageDetails.personId
  const contributorId = messageDetails.contributorId

  const personSummary = queueCachesState.personsCache[personId]
  const personLabels = queueCachesState.labelsCache[personId]
  const userSummary = queueCachesState.usersCache[contributorId]

  const category = messageDetails.treeCategory
  const categoryLabel = t(`treeCategories.${category}`, { category })

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(personId)
    queueCachesActions.fetchPersonLabels(personId)
    queueCachesActions.fetchUserSummary(contributorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isNullOrUndefined(personSummary) || isNullOrUndefined(personLabels) || isNullOrUndefined(userSummary)) {
    return null
  }

  return (
    <Grid>
      <Cell columns={6}>
        <DataBlock
          heading={t('person', 'Person')}
          data={
            <>
              <PersonLink personId={personId} personName={personSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={personId} treeIcon newTab memories />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributor', 'Contributor')}
          data={<UserLink userId={contributorId} userName={userSummary?.contactName} showId newTab />}
        />
      </Cell>
      {messageDetails.duplicatePersonId && (
        <Cell columns={6}>
          <DataBlock
            heading={t('queues.duplicatePersonId', 'Duplicate Person ID')}
            data={
              <>
                <PersonLink personId={messageDetails.duplicatePersonId} forward={false} />
                <TreePersonLink personId={messageDetails.duplicatePersonId} treeIcon newTab memories />
              </>
            }
          />
        </Cell>
      )}
      <Grid>
        <Cell columns={6}>
          <DataBlock heading={t('queues.treeId', 'Tree ID')} data={<TreeLink treeId={messageDetails.treeId} />} />
        </Cell>
        <Cell columns={6}>
          <DataBlock heading={t('queues.treeCategory', 'Tree Category')} data={categoryLabel} />
        </Cell>
      </Grid>
    </Grid>
  )
}
